// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { headerClickableStyles } from "@guestsupply/App/Components/Header/HeaderClickable";
import { color, hideElement, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

headerClickableStyles.clickable = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        margin: auto;
        position: relative;
        &:hover,
        &.opened {
            .line-count {
                background-color: ${color("common.ui9")};
            }
            ${TypographyStyle} {
                cursor: pointer;
            }
            ${IconWrapper} {
                color: ${color("primary")};
                cursor: pointer;
            }
        }
        &.mobile-mode:not(.mobile-search-button) {
            display: flex;
            justify-content: center;
            ${xScreen("lte", "md")} {
                width: 26px;
                height: 26px;
            }
        }

        &:focus {
            outline: none;
        }
    `,
};
headerClickableStyles.title = {
    size: 12,
    color: "text.main",
    css: css`
        letter-spacing: 0;
        line-height: 13px;
        display: block;
        max-width: 120px;
        text-transform: capitalize;
        white-space: nowrap;
        &:not(.break-words) {
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .break-words {
            white-space: pre-wrap;
        }

        & > .sub-title {
            display: block;
            white-space: nowrap;
            font-weight: 400;
            line-height: 18px;
            margin-bottom: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            color: ${color("common.ui3")};
            font-size: 14px;
        }

        &:hover {
            cursor: pointer;
        }

        ${xScreen("lte", "md")} {
            ${hideElement}
        }
        &.sticky {
            ${hideElement}
        }
    `,
};
headerClickableStyles.icon = {
    size: 26,
};
headerClickableStyles.cartWrapper = {
    css: css`
        height: 29px;
        position: relative;
        ${xScreen("lte", "md")} {
            height: 22px;
        }
    `,
};
